var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm.divisions
        ? [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: _vm.selectorId } },
              [
                _vm._v(
                  _vm._s(_vm.resource("TemplateShare_SelectedDivisionId_Label"))
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group" }, [
              _c(
                "div",
                { staticClass: "col-8" },
                [
                  _c("division-dropdown", {
                    attrs: {
                      "exclude-own-division": true,
                      "division-list": _vm.divisions,
                      id: _vm.selectorId
                    },
                    model: {
                      value: _vm.selectedDivisionId,
                      callback: function($$v) {
                        _vm.selectedDivisionId = $$v
                      },
                      expression: "selectedDivisionId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.promptShareRecord }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "TemplateShare_ShareWithDivision_Button_Text"
                        )
                      )
                    )
                  ]
                )
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-8" }, [
          _c("label", { staticClass: "control-label" }, [
            _vm._v(
              _vm._s(_vm.resource("TemplateShare_SharedWith_Divisions_Label"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4" }, [
          _c("label", { staticClass: "control-label" }, [
            _vm._v(
              _vm._s(_vm.resource("TemplateShare_SharedWith_Published_Label"))
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.divisionSharedTemplates, function(sharedTemplate) {
        return _c(
          "div",
          { key: sharedTemplate.divisionId, staticClass: "row" },
          [
            _c("div", { staticClass: "col-8" }, [
              _vm._v(
                "\n            " + _vm._s(sharedTemplate.name) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                sharedTemplate.isPublished
                  ? [_c("i", { staticClass: "fas fa-lg fa-check" })]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm._m(0, true)
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("hr", { staticClass: "my-3" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }